<div class="scroll-container" (scroll)="onScroll($event)">
<div *ngFor="let course of courses">
<div class="course-card p-4">
    <div class="course-content">

        <div class="left w-75">
            <h2 class="text-white">{{course.name}}</h2>
            <p class="subtitle" *ngIf="course.accessdays > 0">
                {{course.accessdays}}-day program  
                <span
                    *ngIf="course.virtualInstructor">Virtual Instructor-Led
                </span>
            </p>

            <div class="meta">
                <div class="meta-item">
                    <div *ngIf="course.virtualInstructor">
                        <i class="fa fa-calendar"></i>
                        <span *ngIf="course.startDate; else noDate">
                            Starts {{ course.startDate | date:'EEE, MMM d, y' }}
                        </span>

                        <ng-template #noDate>
                            <span>Available now — start any time.</span>
                        </ng-template>
                    </div>

                    <div *ngIf="course.nextBatchDate && course.allowBatches">
                        Next Batch: {{this.util.formatDate(course.nextBatchDate)}}
                    </div>
                </div>
                
                <div *ngIf="course.virtualInstructor && course.virtualSchedule" class="meta-item">                    
                    <span><i class="fa fa-desktop"></i> Virtual Instructor-Led  </span>                    
                    <span><i class="far fa-clock"></i> {{course.virtualSchedule}}</span>
                </div>
            </div>
        </div>

        <div class="right w-25">
            <a [routerLink]="['/site/moduledetails']" [queryParams]="{ moduleID: course.id }" class="details-link">
                View Course Details →
            </a>
        </div>

    </div>
</div>
</div>
    
</div>
<div *ngIf="loading" class="text-center">
    Loading...
  </div>